import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SelectAsyncPaginate, Select, SelectAsync } from '@Thread-Magic/jasmine';

import { useTheme } from 'styled-components';

import * as Styled from './styles';
import {
  CustomClearIndicator,
  CustomMultiValue,
  CustomMultiValueRemove,
  CustomOption
} from './components';

const SelectByType = (type, props) => {
  const types = {
    paginate: SelectAsyncPaginate,
    async: SelectAsync,
    basic: Select
  };

  const Component = types[type];

  return <Component {...props} />;
};

const CustomMultiSelect = ({
  label,
  description,
  shouldPaginate,
  componentType,
  components,
  placeholder,
  showPlaceholderAsCount,
  ...props
}) => {
  const theme = useTheme();
  const getPlaceholderValue = value => {
    if (showPlaceholderAsCount) {
      return value?.length ? `${value.length} selected` : 'Select...';
    }
    return placeholder;
  };
  return (
    <Fragment>
      {label && <Styled.LabelStyled>{label}</Styled.LabelStyled>}
      {description && <Styled.DescStyled>{description}</Styled.DescStyled>}
      {SelectByType(componentType, {
        ...props,
        isMulti: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        blurInputOnSelect: false,
        theme,
        placeholder: getPlaceholderValue(props.value),
        components: {
          Option: components?.Option || CustomOption,
          MultiValue: components?.MultiValue || CustomMultiValue,
          ValueContainer: components?.ValueContainer || Styled.ValueContainer,
          ClearIndicator: components?.ClearIndicator || CustomClearIndicator,
          MultiValueRemove: components?.MultiValueRemove || CustomMultiValueRemove
        }
      })}
    </Fragment>
  );
};

CustomMultiSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  componentType: PropTypes.string,
  placeholder: PropTypes.string,
  shouldPaginate: PropTypes.bool,
  getOptionValue: PropTypes.func,
  getOptionLabel: PropTypes.func,
  customStyles: PropTypes.object,
  components: PropTypes.object,
  showPlaceholderAsCount: PropTypes.bool
};

CustomMultiSelect.defaultProps = {
  label: null,
  description: null,
  shouldPaginate: false,
  showPlaceholderAsCount: false,
  componentType: 'basic',
  placeholder: 'Select...',
  getOptionValue: option => option.id,
  getOptionLabel: option => option.name,
  customStyles: {
    control: () => ({
      minHeight: 40
    })
  },
  components: {}
};

export default CustomMultiSelect;
